import { connectRouter } from 'connected-react-router/immutable';

export default function createReducer(history) {
  return connectRouter(history);
}
